"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnauthenticatedClient = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
// eslint-disable-next-line import/prefer-default-export
var _http = /*#__PURE__*/new WeakMap();
class UnauthenticatedClient {
  constructor(baseUrlArg) {
    _classPrivateFieldInitSpec(this, _http, null);
    const baseUrl = typeof baseUrlArg !== 'undefined' ? baseUrlArg : _ApplicationContext.ApplicationContext.getApiBasePath();
    _classPrivateFieldSet(_http, this, _axios.default.create({
      baseURL: baseUrl,
      withCredentials: true
    }));
  }
  get(url, options) {
    return this.getClient().get(url, options);
  }
  postFormData(url, formData) {
    return this.getClient().post(url, formData);
  }
  postBody(url, body) {
    return this.getClient().post(url, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  getClient() {
    return _classPrivateFieldGet(_http, this);
  }
}
exports.UnauthenticatedClient = UnauthenticatedClient;
//# sourceMappingURL=UnauthenticatedClient.js.map